/**
 * "from [Orbion logo]" credit attribution.
 * Used on auth screens and at the bottom of the sidebar nav.
 */
export function OrbionCredit({ size = 'sm', align = 'center' }) {
    const heights   = { sm: 13, md: 16, lg: 20 };
    const fontSizes = { sm: '0.6rem', md: '0.68rem', lg: '0.78rem' };
    const gaps      = { sm: '0.55rem', md: '0.7rem', lg: '0.85rem' };

    return (
        <div
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: align === 'center' ? 'center' : 'flex-start',
                gap: gaps[size],
            }}
        >
            <span
                style={{
                    fontSize: fontSizes[size],
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.22em',
                    color: 'rgba(138, 151, 176, 0.42)',
                    lineHeight: 1,
                }}
            >
                from
            </span>
            <img
                src="/logo orbion.png"
                alt="Orbion"
                style={{
                    height: `${heights[size]}px`,
                    width: 'auto',
                    display: 'block',
                    opacity: 0.78,
                    filter: 'drop-shadow(0 0 6px rgba(0, 214, 143, 0.18))',
                }}
            />
        </div>
    );
}
